import type { ModuleConfig } from "./moduleConfig.types";
import { equityModuleConfig } from "./config/equity.config";
import { conversionModuleConfig } from "./config/conversion.config";
import { emotionalModuleConfig } from "./config/emotional.config";
import { advertisingModuleConfig } from "./config/advertising.config";
import { visibilityModuleConfig } from "./config/visibility.config";
import { reputationModuleConfig } from "./config/reputation.config";
import { exclusiveQuestionsModuleConfig } from "./config/exclusivequestions.config";
import { reportsModuleConfig } from "./config/reports.config";
import { aiVisibilityModuleConfig } from "./config/aivisibility.config";

/**
 * Registry that maps an UPPERCASE module name (matching `userSelection.module`
 * after `.toUpperCase()`) to its hierarchical {@link ModuleConfig} object.
 *
 * Add a new entry here whenever a new module config file is created.
 *
 * Route path `/aivisibility` is mapped to `AI_VISIBILITY` in `useURLToStore`
 * (same pattern as `/emotional` → `IMAGERY`).
 */
export const MODULE_CONFIG_REGISTRY: Record<string, ModuleConfig> = {
  EQUITY: equityModuleConfig,
  CONVERSION: conversionModuleConfig,
  EMOTIONAL: emotionalModuleConfig,
  ADVERTISING: advertisingModuleConfig,
  VISIBILITY: visibilityModuleConfig,
  REPUTATION: reputationModuleConfig,
  EXCLUSIVEQUESTIONS: exclusiveQuestionsModuleConfig,
  REPORTS: reportsModuleConfig,
  AI_VISIBILITY: aiVisibilityModuleConfig,
};